import Quill from 'quill';
import { i18n } from '@/plugins/vue-i18n';
import './css/embed.styl';

const BlockEmbed = Quill.import('blots/block/embed');

function createButton(icon) {
  const title = i18n.te(`message.editor.option.${icon}`)
    ? i18n.t(`message.editor.option.${icon}`)
    : null;
  return `
  <button type="button" class="v-btn v-btn--icon btn__${icon}" data-ripple="false" title="${title}">
    <div class="v-btn__content">
      <i aria-hidden="true" class="v-icon material-icons">${icon}</i>
    </div>
  </button>
`;
}

function addButton(types) {
  let html = '';

  types.forEach((type) => {
    html += createButton(type);
  });

  return html;
}

function createMediaWrapper(iconName, iconClass, image, dense) {
  let imageHtml = '';
  let iconHtml = '';
  let invertIcon = '';

  if (image) {
    imageHtml = `<img src="${image}">`;
    invertIcon = 'v-icon--white';
  }
  if (iconName || iconClass) {
    iconHtml = `<i class="v-icon material-icons ${iconClass} ${invertIcon}">${iconName}</i>`;
  }
  if (image || iconName || iconClass) {
    return `<figure class="ql-media-wrapper ${dense ? 'ql-media-wrapper--dense' : ''}">${imageHtml} ${iconHtml}</figure>`;
  }

  return '';
}

function createToolbar(title, types, mediaWrapper) {
  return `
  <nav class="v-toolbar v-toolbar--dense elevation-0 transparent">
    ${mediaWrapper}
    <div class="v-toolbar__content" style="height: 48px;">
    <div class="v-toolbar__title">${title}</div>
    <div class="spacer"></div>
    ${addButton(types)}
    </div>
  </nav>
`;
}

function capitalize(s) {
  return s.replace(/(?:^|\s)\S/g, a => a.toUpperCase());
}

function setData(node, value) {
  Object.entries(value)
    .forEach(([key, data]) => {
      if ((key !== 'label' && key !== 'buttons' && key !== 'options') && (data || data === 0)) {
        node.dataset[`embed${capitalize(key)}`] = data;
      }
    });
}


class Embed extends BlockEmbed {
  static create(value) {
    const node = super.create();
    const buttons = (value.buttons || []).concat('delete');

    node.classList.add('ql-embed');
    node.setAttribute('contenteditable', false);

    setData(node, value);

    const id = value.id || value.contentId || value.embedId;
    const editorTitle = i18n.te(`message.editor.embed.${value.label}`) ? i18n.t(`message.editor.embed.${value.label}`) : value.label;
    const customTitle = value.customTitle ? `- ${value.customTitle}` : '';
    const toolbarTitle = id ? `${editorTitle} - ${id} ${customTitle}` : `${editorTitle} ${customTitle}`;
    node.insertAdjacentHTML(
      'beforeend',
      createToolbar(
        toolbarTitle,
        buttons,
        createMediaWrapper(
          value.iconName,
          value.iconClass,
          value.image,
          typeof value.denseMedia === 'boolean' && value.denseMedia,
        ),
      ),
    );

    buttons.forEach((type) => {
      node.querySelector(`.btn__${type}`)
        .addEventListener('click', () => {
          node.dispatchEvent(new Event(`quill-embed-${type}`, {
            bubbles: true,
          }));
        });
    });

    return node;
  }
}

export default Embed;
